
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* =========================
   AXIOS INSTANCE
========================= */
const apiClient = axios.create({
  //  baseURL: 'http://localhost:3200',
 
  // baseURL: 'https://jaimarutilogistics.com/ShipwayApi',

  // ========================arhatgloballink ======================

  // baseURL: 'https://arhatglobal.com/FutureinfosysApi',

  //  =====================bW World wise link  ==========================
    // baseURL: 'https://arhatglobal.com/TrackingApi',


    // ======================Tsscouirer link ====================
    // baseURL: 'https://airkingexpress.net/TrackingApi',

    //  baseURL: 'https://airkingexpress.net/TrackingApi',

      // baseURL: 'https://api.futureinfosys.in/TscApi',

       baseURL: 'https://api.futureinfosys.in/Shreeramji',



  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 sec timeout
});

/* =========================
   API METHODS
========================= */

export const getApi = async (url, config = {}) => {
  try {
    const response = await apiClient.get(url, config);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const postApi = async (url, data, config = {}) => {
  try {
    const response = await apiClient.post(url, data, config);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const putApi = async (url, data, config = {}) => {
  try {
    const response = await apiClient.put(url, data, config);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const deleteApi = async (url, config = {}) => {
  try {
    const response = await apiClient.delete(url, config);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

/* =========================
   ERROR HANDLER
========================= */
const handleApiError = (error) => {
  if (error?.response) {
    // Backend responded with error
    toast.error(
      error.response.data?.message ||
      error.response.data?.error ||
      'Server error'
    );
  } else if (error?.request) {
    // Request made but no response
    toast.error('Server not responding (Network / CORS issue)');
  } else {
    // Something else happened
    toast.error(error?.message || 'Unexpected error');
  }
};
